package com.dotdrives.repository

import com.dotdrives.client.WorkflowClient
import com.dotdrives.model.WorkflowRequest
import kotlinx.serialization.json.JsonObject

interface WorkflowRepository {
    suspend fun execute(request: WorkflowRequest): Result<JsonObject>
}

class SupabaseWorkflowRepository(private val client: WorkflowClient = WorkflowClient()) :
    WorkflowRepository {
    override suspend fun execute(request: WorkflowRequest): Result<JsonObject> = runCatching {
        client.execute(request)
    }
}
